import type { PocInputValidity } from 'commons/types';
import {
    ConnectionFormFieldErrors,
    ConnectionFormFieldName,
    getRequiredFieldError,
} from './active-directory-connection-details-form.business';

export const getFieldValidity = (
    field: ConnectionFormFieldName,
    formState: Record<ConnectionFormFieldName, string>,
    touched: Set<ConnectionFormFieldName>,
    fieldErrors: ConnectionFormFieldErrors,
    hasSavedPassword?: boolean
): PocInputValidity | undefined => {
    if (fieldErrors[field]) {
        return { state: 'error', type: ['custom'] };
    }
    if (touched.has(field) && getRequiredFieldError(field, formState[field], hasSavedPassword)) {
        return { state: 'error', type: ['value-missing'] };
    }
    return undefined;
};
